import { simpleFetch } from './customFetch';

export const getCouponContent = (coupon, screenKey) =>
  simpleFetch(
    `/contents/self/${screenKey}/coupon${coupon ? `-${coupon}` : ''}`,
    {},
    process.env.REACT_APP_CONTENT_API,
  );
